@if (isOpen()) {
  <div
    class="fixed inset-0 bg-black/60 backdrop-blur-[1px] z-50 flex items-start justify-center p-4 md:px-0 overflow-y-auto animate-fade-in"
  >
    <div
      class="bg-white rounded-lg shadow-xl w-full lg:max-w-[80%] md:max-w-[85%] max-w-[95%] my-auto animate-slide-up max-h-[90vh] overflow-y-auto"
      role="dialog"
      aria-modal="true"
    >
      <!-- Header -->
      <div class="flex items-center gap-3 bg-secondary/20 p-6 py-4 border-b border-border-2 rounded-t-lg">
        <span class="material-symbols-outlined text-2xl! text-secondary">person</span>
        <h2 class="text-heading-primary font-semibold font-heading text-lg">
          Completa tu perfil de usuario para continuar
        </h2>
      </div>

      <!-- Body -->
      <div class="p-6 relative">
        <app-loading [isLoading]="isLoading()"></app-loading>
        <app-error-modal
          [isOpen]="showError"
          [type]="errorType()"
          [message]="errorMessage()"
          (close)="showError.set(false)"
        ></app-error-modal>

        <p class="text-text-body mb-6 text-sm">
          Necesitamos algunos datos para completar tu perfil de usuario. Por favor completa el formulario y guarda para continuar.
        </p>

        @if (userData() && catalogs()) {
          <app-dynamic-form
            [fields]="userSchema"
            [catalogs]="catalogs()"
            [formData]="userData()"
            submitButtonText="Guardar y continuar"
            (formChange)="onFormChange($event)"
            (formSubmit)="onSubmit($event)"
          ></app-dynamic-form>
        }
      </div>
    </div>
  </div>
}
